import type { TLinkElement } from '@alpod-ai-writer/plate-plugins/link';
import { useLink } from '@alpod-ai-writer/plate-plugins/link/react';
import { cn, withRef } from '@udecode/cn';
import { PlateElement } from '@udecode/plate/react';

export const LinkElement = withRef<typeof PlateElement>(
    ({ children, className, ...props }, ref) => {
        const element = props.element as TLinkElement;
        const { props: linkProps } = useLink({ element });
        return (
            <PlateElement
                ref={ref}
                as="a"
                className={cn(
                    className,
                    'font-medium text-primary underline decoration-primary underline-offset-4'
                )}
                {...(linkProps as any)}
                {...props}
            >
                {children}
            </PlateElement>
        );
    }
);
